export default __webpack_public_path__ + "static/media/656.178a3a8f.png";